/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ScheduleUpdatesType {
    ScheduleUpdateOn,
    StartNow,
    Cancel,
}
